import React from 'react';
import { merge } from 'lodash';

const AddressField = ({ component: Component, variant = 'standard', autoComplete = false, ...rest }) => {
  const newProps = merge(
    {
      InputProps: {
        inputProps: {
          autoComplete: autoComplete || 'chrome-off',
        },
      },
    },
    rest
  );

  return <Component {...newProps} variant={variant} />;
};

export default AddressField;
